import weather from "./redux/weather";
import counter from "./redux/counter";
import user from "./redux/user";
import clinics from "./redux/clinics";
import clients from "./redux/clients";
import cronexpressions from './redux/cronexpressions';
import chores from './redux/chores';
import notificationchores from './redux/notificationchores';
import ensure from './redux/ensure';
import campaignmonitor from './redux/campaignmonitor';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';


export default (history) => combineReducers({
    router: connectRouter(history),
    counter,
    weather,
    user,
    clinics,
    clients,
    cronexpressions,
    chores,
    notificationchores,
    campaignmonitor,
    ensure
});


// WEBPACK FOOTER //
// ./src/reducers.js